import { NgModule } from '@angular/core';
import { LocalService } from '../local.services';
import { SharedModule } from '@core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AppThankComponent } from './thank.component';
const routes = [
    {
        path: '',
        component: AppThankComponent,
        resolve: {
            local: LocalService
        }
    }
];

@NgModule({
    declarations: [
        AppThankComponent,
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
    ],
    providers: [

    ]
})

export class LocalStepThankModule {

}
